import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { CampaignSignupClient } from '../api/api.g';
import useApi from './api-hook';
import { useAppSelector } from './store-hook';
import { LoggedState } from '../models/AuthModelsCommon';
export default function useCampaignSecurity() {
  const auth = useAppSelector(s => s.auth);
  const api = useApi(CampaignSignupClient);
  const enabled = !!auth.idToken && auth.logged === LoggedState.Logged;
  const query = useQuery({
    queryKey: ['campaignSecurity', auth.user?.uid],
    enabled,
    queryFn: () => api.getCampaignSecurity(undefined),
    refetchInterval: 30_000,
    retry: false,
    useErrorBoundary: false
  });
  // Refresh security on a token change without unmounting navigation on every
  // routine Firebase token refresh. Logout already clears the query cache.
  useEffect(() => {
    if (enabled) {
      void query.refetch();
    }
  }, [auth.idToken, enabled]);
  return {
    ...query,
    checking: enabled && !query.isSuccess,
    allowed: !enabled || query.isSuccess && query.data.accessAllowed
  };
}
